import React from 'react';

/**
 * 얇은 체브론 — Figma 페이지네이션 화살표 에셋(node 4347-9677)의 path 그대로.
 * 원본은 오른쪽 방향 한 벌뿐이라 나머지 방향은 svg 내부 `<g transform>` 회전으로 만든다 —
 * 내부 회전이라 호출부가 className 으로 거는 `rotate-*`(--tw-rotate)와 다투지 않는다
 * (`chevron-icons.tsx` 의 경고와 같은 이유 — 칩 여닫이 토글이 실제 사용처다).
 * fill 은 currentColor — 색은 부모가 정한다.
 */
const ROTATION = {
  right: undefined,
  left: 'rotate(180 12 12)',
  down: 'rotate(90 12 12)',
  up: 'rotate(-90 12 12)',
} as const;

export type ChevronThinDirection = keyof typeof ROTATION;

export function ChevronThinIcon({
  direction,
  className,
}: {
  direction: ChevronThinDirection;
  className?: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g transform={ROTATION[direction]}>
        <path
          d="M10.6464 7.64644C10.8416 7.45118 11.1582 7.45118 11.3534 7.64644L15.3534 11.6464C15.5487 11.8417 15.5487 12.1582 15.3534 12.3535L11.3534 16.3535C11.1582 16.5487 10.8416 16.5487 10.6464 16.3535C10.4511 16.1582 10.4511 15.8417 10.6464 15.6464L14.2929 12L10.6464 8.35348C10.4511 8.15821 10.4511 7.84171 10.6464 7.64644Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
